import React, { ReactElement } from 'react';
import Select from 'react-select';
import { Text, Box } from 'rebass/styled-components';
import { StylesConfig } from 'react-select';

type ReactSelectProps = {
  name: string | undefined;
  options:
  | Array<{ value: number | string; label: string | undefined | any }>
  | undefined;
  inputValue?: string;
  isClearable?: boolean;
  isSearchable?: boolean;
  className?: string;
  classNamePrefix?: string;
  isMulti?: boolean;
  required?: boolean;
  label?: string;
  disabled?: boolean;
  onChange?: any;
  onBlur?: any;
  onMenuOpen?: any;
  styles?: StylesConfig;
  value?: { value: number | string; label: string | undefined } | undefined;
  placeholder?: string;
  menuPlacement?: 'auto' | 'bottom' | 'top';
  onInputChange?: (inputValue: string, action?: any) => void;
  isLoading?: boolean;
  loadingMessage?: () => string;
  menuPortalTarget?: HTMLElement;
  menuShouldScrollIntoView?: boolean;
  noOptionsMessage?: () => string;
};

function ReactSelect({
  name,
  options,

  isClearable,
  isSearchable,
  className,
  inputValue,
  classNamePrefix,
  isMulti,
  required,
  label,
  disabled,
  onChange,
  onBlur,
  styles,
  value,
  onMenuOpen,
  placeholder,
  menuPlacement,
  onInputChange,
  isLoading,
  loadingMessage,
  menuPortalTarget,
  menuShouldScrollIntoView,
  noOptionsMessage
}: ReactSelectProps): ReactElement {
  return (
    <>
      {required ? (
        <Box marginBottom="xxsmall">
          <Text required>{label}</Text>
        </Box>
      ) : (
        <Box marginBottom="xxsmall">
          <Text fontWeight="medium">{label}</Text>
        </Box>
      )}

      <Select
        options={options}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isMulti={isMulti}
        isDisabled={disabled}
        className={className}
        classNamePrefix={classNamePrefix}
        onChange={onChange}
        onBlur={onBlur}
        styles={styles}
        value={value}
        onMenuOpen={onMenuOpen}
        placeholder={placeholder}
        menuPlacement={menuPlacement}
        onInputChange={onInputChange}
        isLoading={isLoading}
        loadingMessage={loadingMessage}
        menuPortalTarget={menuPortalTarget}
        menuShouldScrollIntoView={menuShouldScrollIntoView}
        noOptionsMessage={noOptionsMessage}
        inputValue={inputValue}
      />
    </>
  );
}

export { ReactSelect };
